<template>
    <app-layout title="Rollen">
        <template #header>
            <page-title title="Rol aanmaken" />
        </template>

        <template #pageContent>
            <Form layout="columns" @submit="createRole">
                <div>
                    <Input label="Naam" name="name" v-model="form.name" required :error="form.errors.name" layout="vertical"/>
                    <Input label="Omschrijving" name="description" type="text"  v-model="form.description" required :error="form.errors.description" layout="vertical"/>
                    <Input label="Slug" name="slug" type="text" v-model="form.slug" required :error="form.errors.slug" layout="vertical"/>
                    <Input label="Niveau" name="level" type="number"  v-model="form.level" :error="form.errors.level" required layout="vertical"/>
                    <InputGroup label="Overerfbaar" :required="true" :error="form.errors.inheritable" layout="vertical">
                        <Input label="Ja" name="inheritable" value="1" type="radio" v-model="form.inheritable" required :checked="form.inheritable == '1'"/>
                        <Input label="Nee" name="inheritable" value="0" type="radio" v-model="form.inheritable" required :checked="form.inheritable == '0'"/>
                    </InputGroup>
                </div>
                <div class="flex flex-col">
                    <div class="pt-1.5">
                        <Label for="departments" label="Afdelingen" class="flex-none" id="label_departments"></Label>
                        <Multiselect
                            v-model="form.departments"
                            :options="departments"
                            mode="tags"
                            id="departments"
                            :searchable="true"
                            placeholder="selecteer een afdeling"
                            :closeOnSelect="false"
                        />
                        <Error :error="form.errors.departments" v-if="form.errors.departments" />
                    </div>

                    <div class="mt-3">
                        <Label for="permissions" label="Rechten" class="flex-none" id="label_permissions"/>
                        <Multiselect
                            v-model="form.permissions"
                            :options="permissions"
                            mode="tags"
                            id="permissions"
                            :searchable="true"
                            placeholder="selecteer een recht"
                            :closeOnSelect="false"
                        />
                        <Error :error="form.errors.permissions" v-if="form.errors.permissions" />
                    </div>

                    <div class="flex mt-auto flex-wrap justify-end">
                        <Button
                            htmlType="a"
                            buttonClass="cancel"
                            title="Annuleren"
                            text="Annuleren"
                            :href="route('admin.roles')"
                        />
                        <Button text="Rol aanmaken" buttonType="submit" buttonClass="save"/>
                    </div>

                </div>
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'
import InputGroup from '@/Components/InputGroup.vue'
import Label from '@/Components/Label.vue'
import Error from '@/Components/Error.vue'

import { useForm } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Input,
        Select,
        Form,
        Multiselect,
        InputGroup,
        Label,
        Error
    },
    props:[
        'departments',
        'permissions'
    ],
    data() {
        return {}
    },
    setup (props){
        let form = useForm({
            name: '',
            description: '',
            slug: '',
            level: 0,
            inheritable: true,
            permissions: [],
            departments: [],
        })

        function createRole(){
            form.post('/admin/roles')
        }

        return {
            state: store.state,
            ...store,
            form,
            createRole
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
    },
}

</script>
